/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { lazy } from "react";
import { Loadable } from "components/Loadable";
// import DigitalAssets from 'sections/digital_assets/index'
// import { DigitalAssetsContextWrapper } from 'sections/digital_assets/context/digital-assets-context-wrapper'

const DigitalAssets = Loadable(lazy(() => import("sections/digital_assets/index")));
const ImageLibraryGalleryTab = Loadable(lazy(() => import("sections/digital_assets/images/library-gallery-tab")));
const ImageLibraryListTab = Loadable(lazy(() => import("sections/digital_assets/images/image-list-tab")));
const ImageLibraryUploadTab = Loadable(lazy(() => import("sections/digital_assets/images/image-upload-tab")));
const ImageLibraryLayoutTab = Loadable(lazy(() => import("sections/digital_assets/images/image-library-layout")));
const DocumentsLibraryTab = Loadable(lazy(() => import("sections/digital_assets/documents/index")));
const LinksLibraryTab = Loadable(lazy(() => import("sections/digital_assets/links/index")));
const DocumentsListTab = Loadable(lazy(() => import("sections/digital_assets/documents/tabs/document-list")));
const DocumentsUploadTab = Loadable(lazy(() => import("sections/digital_assets/documents/tabs/document-upload")));

const digitalAssetsRoutes = [
    {
        path: "digital-assets",
        // element: <DigitalAssetsContextWrapper><DigitalAssets /></DigitalAssetsContextWrapper>,
        element: <DigitalAssets />,
        children: [
            {
                index: true,
                element: <ImageLibraryLayoutTab />,
                // element: <> Index </>,
                // loader: () => redirect("/digital-assets/images"),
            },
            {
                path: "images",
                element: <ImageLibraryLayoutTab />,
                children: [
                    {
                        index: true,
                        element: <ImageLibraryGalleryTab />,
                    },
                    {
                        path: "gallery",
                        element: <ImageLibraryGalleryTab />,
                    },
                    {
                        path: "list",
                        element: <ImageLibraryListTab />,
                    },
                    {
                        path: "upload",
                        element: <ImageLibraryUploadTab />,
                    },
                ]
            },
            {
                path: "documents",
                element: <DocumentsLibraryTab />,
                // element: <> Documents</>,
                children: [
                    {
                        index: true,
                        element: <DocumentsListTab />,
                    },
                    {
                        path: "list",
                        element: <DocumentsListTab />,
                    },
                    {
                        path: "upload",
                        element: <DocumentsUploadTab />,
                    },
                ]
            },
            {
                path: "links",
                element: <LinksLibraryTab />,
            },
            // {
            //     path: 'attachments',
            //     element: <AttachmentsLibraryTab />,
            // },
        ]
    }
];
export { digitalAssetsRoutes };
